import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, HeadlineL } from '#src/atoms/typography/index.tsx';
import { useConnectionContext } from '#src/contexts/connection/index.tsx';
import { Placeholder as WalletPlaceholder } from '#src/contexts/wallet/Placeholder/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const Frame = styled(WalletPlaceholder)`
  margin-top: 10px;
  position: relative;
  top: 0;
  height: 200px;
`;

type Props = {
  hasSubmitted: boolean;
};

export const ResetPasswordContent = ({ hasSubmitted }: Props) => {
  const { signIn } = useConnectionContext();
  const [, setSearchParams] = useSearchParams();

  if (hasSubmitted) {
    return (
      <Vertical gap={2}>
        <HeadlineL as="h3" className="text-center">
          <FormattedMessage defaultMessage="You’re all set" />
        </HeadlineL>
        <BodyM color="var(--c-white)" className="text-center">
          <FormattedMessage defaultMessage="Your new password has been saved. You can try to sign in using your new password." />
        </BodyM>
        <Button
          size="medium"
          color="primary"
          onClick={() => {
            signIn();
            setSearchParams({});
          }}
        >
          <FormattedMessage {...glossary.signin} />
        </Button>
      </Vertical>
    );
  }
  return (
    <Vertical gap={2}>
      <HeadlineL as="h3">
        <FormattedMessage defaultMessage="Create your new password" />
      </HeadlineL>
      <BodyM color="var(--c-white)">
        <FormattedMessage defaultMessage="Enter a new password to secure your Sorare account. It must be at least six characters long." />
      </BodyM>
      <BodyM color="var(--c-white)">
        <FormattedMessage defaultMessage="Setting a new password will require you to recover your Sorare wallet the next time you log in." />
      </BodyM>
      <Frame />
    </Vertical>
  );
};
